import './App.css';

function Messages() {
    return (
    <div className="Messages">
        <div className='flex-container'>
            <div className='inbox'>
                <h1>Messages</h1>
                <div className='under'></div>
                <div className='inbox-name'>
                    <div className='box'>
                        <div className='icon'>
                                SW
                        </div>
                        <div>
                            <h2>Scott White</h2>
                            <p>Business name</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className='chat'>
                <div className='chat-header'>
                    <div className='chatname'>
                        <div className='icon'>
                            SW
                        </div>
                        <div>
                            <h2>Scott White</h2>
                            <p>Business name</p>
                        </div>
                    </div>
                    <a href='/messages'>
                        <div className='view-prof'>
                        <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M12 0c-5.083 0-8.465 4.949-3.733 13.678 1.596 2.945-1.725 3.641-5.09 4.418-3.073.709-3.187 2.235-3.177 4.904l.004 1h23.99l.004-.969c.012-2.688-.093-4.223-3.177-4.935-3.438-.794-6.639-1.49-5.09-4.418 4.719-8.912 1.251-13.678-3.731-13.678m0 1c1.89 0 3.39.764 4.225 2.15 1.354 2.251.866 5.824-1.377 10.06-.577 1.092-.673 2.078-.283 2.932.937 2.049 4.758 2.632 6.032 2.928 2.303.534 2.412 1.313 2.401 3.93h-21.998c-.01-2.615.09-3.396 2.401-3.93 1.157-.266 5.138-.919 6.049-2.94.387-.858.284-1.843-.304-2.929-2.231-4.115-2.744-7.764-1.405-10.012.84-1.412 2.353-2.189 4.259-2.189"/></svg>
                            &nbsp;&nbsp;View Profile
                        </div>
                    </a>
                </div>
                <div className='under'></div>
                {/* sample chat */}
                <div className='chat-history'>
                    <div className='send'>
                        <div className='bubble'>
                            <h2>David Johnson</h2>
                            <p>I would like to make an inquiry about my tax write-off. Specifically, my deductions.</p>
                        </div>
                        <div className='icon'>DJ</div>
                    </div>
                    <div className='receive'>
                        <div className='icon'>SW</div>
                        <div className='bubble'>
                            <h2>Scott White</h2>
                            <p>Of course! I'd be happy to help. What specific deductions are you
                            curious about?</p>
                        </div>
                    </div>
                    <div className='send'>
                        <div className='bubble'>
                            <h2>David Johnson</h2>
                            <p>Well, I work from home, so I'm wondering if I can deduct any expenses
                            related to that?</p>
                        </div>
                        <div className='icon'>DJ</div>
                    </div>
                    <div className='receive'>
                        <div className='icon'>SW</div>
                        <div className='bubble'>
                            <h2>Scott White</h2>
                            <p>Absolutely, there are several home office deductions you may qualify
                            for. Have you kept track of your home office expenses?</p>
                        </div>
                    </div>
                    <div className='send'>
                        <div className='bubble'>
                            <h2>David Johnson</h2>
                            <p>Yes, I have records of my internet bill, a portion of my rent, and some
                            office supplies I purchased.</p>
                        </div>
                        <div className='icon'>DJ</div>
                    </div>
                    <div className='receive'>
                        <div className='icon'>SW</div>
                        <div className='bubble'>
                            <h2>Scott White</h2>
                            <p>Great, those are all potentially deductible expenses. We'll just need to 
                                determine what percentage of your home is used exclusively for business.</p>
                        </div>
                    </div>
                </div>
                {/* sample chat end */}
                <div className='chat-text'>
                    <textarea placeholder='Write a message'></textarea>
                    <br/>
                    <div className='attach'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#1677ff" viewBox="0 0 24 24"><path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm7 14h-5v5h-4v-5h-5v-4h5v-5h4v5h5v4z"/></svg>
                    &nbsp; Attach File
                    </div>
                </div>
            </div>


        </div>
    </div>
  );
}

export default Messages;
